import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import cx from 'classnames'
import Container from '../Container'
import Loading from '../Loading'
import MessagePreview from '../MessagePreview'
import './index.css'

function getRandColor() {
  const colors = [
    '#ff00ff',
    '#00ffff',
    '#00ff33',
    '#ffff33',
  ]

  return colors[Math.floor(Math.random() * (colors.length - 1))]
}

class Message extends PureComponent {
  state = {
    isLoading: true,
    message: null,
    prev: null,
    next: null,
  }

  componentDidMount() {
    this.fetchMessage(this.props.params.id)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.fetchMessage(nextProps.params.id)
    }
  }

  fetchMessage(id) {
    this.setState(
      {
        isLoading: true,
        message: null,
      },
      () => fetch(`/server/public/read.php?id=${ id }`)
        .then((response) => response.json())
        .then(({ message, prev, next }) => this.setState({
          isLoading: false,
          message,
          prev,
          next,
        })),
    )
  }

  getImageUrl(image) {
    if (image.startsWith('http')) {
      return image
    }

    return `/server/images/${ image }`
  }

  render() {
    const { isLoading, message, prev, next } = this.state
    const color = getRandColor()

    return (
      <Container
        background={ !isLoading ? `url(${ this.getImageUrl(message.image) })` : '' }
        backgroundInner={ color }>
        <div>
          <Link
            to={ prev ? `/message/${ prev.id }` : '' }
            className={ cx('message-link', { 'is-disabled': !prev }) }
            style={ { color } }>
            { '<' }
          </Link>

          <Link
            to={ next ? `/message/${ next.id }` : '' }
            className={ cx('message-link', { 'is-disabled': !next }) }
            style={ { color } }>
            { '>' }
          </Link>
        </div>

        { isLoading ? <Loading /> : (
          <MessagePreview
            content={ message.content }
            name={ message.name } />
        ) }
      </Container>
    )
  }
}

export default Message



// WEBPACK FOOTER //
// ./src/components/Message/index.js